import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { UserSettings } from 'src/app/core/models/user-settings.model';

export const UserSettingsActions = createActionGroup({
  source: 'UserSettings',
  events: {
    get_user_settings_start: emptyProps(),
    get_user_settings_success: props<{ userSettings: UserSettings }>(),
    get_user_settings_fail: props<{ error: any }>(),
    set_user_settings_start: props<{ userSettings: UserSettings }>(),
    set_user_settings_success: emptyProps(),
    set_user_settings_fail: props<{ error: any }>(),
    throw_error: props<{ error: any }>(),
    set_user_language_start: props<{ languageCode: string }>(),
    set_user_language_success: emptyProps(),
    set_user_language_fail: props<{ error: any }>()
  }
});
